import { updateDonor } from './updateDonorDetails'

export {
  updateDonor
}
